import { combineReducers } from 'redux';

import population from '../components/vendors_table/redux/index';

export default combineReducers({
  population,
});
